import { render } from "./ContactAuthForm.vue?vue&type=template&id=2833f140"
import script from "./ContactAuthForm.vue?vue&type=script&lang=js"
export * from "./ContactAuthForm.vue?vue&type=script&lang=js"
script.render = render

export default script